export const BASE_URL = "https://lsaperu.com/backend/public/images/";
export const BASE_URL_DOCUMENTS = "https://lsaperu.com/backend/public/";

